import { UilCompress, UilFocus } from '@iconscout/react-unicons'
import { MapControlButton } from 'components/MapV2/Map.style'
import { useMapContext } from 'components/MapV2/MapProvider'
import React from 'react'

export const CustomFullscreen: React.FC = () => {
  const { customFullscreen } = useMapContext()

  if (!customFullscreen) return null

  const { isFullscreen, onFullscreenChange } = customFullscreen

  return (
    <MapControlButton
      data-testid="custom-fullscreen"
      size="medium"
      disabled={false}
      variant="outline"
      color="secondary"
      iconLeft={isFullscreen ? UilCompress : UilFocus}
      onClick={onFullscreenChange}
      onlyIcon
      top={82}
    />
  )
}
